import React, { ComponentProps } from 'react';
import ILink from '../../types/ILink';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import Hyperlink from '../../components/atoms/Hyperlink/Hyperlink';
import { Icons, SVG } from '../../components/atoms/SVG';
import { Heading } from '../../_lib/components/Heading/Heading';
import { useSonTranslation } from '../../translation/useSonTranslation';

type ExternalUserRegistrationProps = {
  externalRegistrationUrl: ILink;
};

function ExternalUserRegistration({ externalRegistrationUrl }: ExternalUserRegistrationProps) {
  const { t } = useSonTranslation('UserRegistration');
  return (
    <div className="external-user-registration">
      <Heading className="external-user-registration__heading" hierarchy={2}>
        {t('externalRegistrationHeadline')}
      </Heading>
      <Hyperlink to={externalRegistrationUrl.url} className="external-user-registration__link">
        <SVG svgSpriteId={Icons.EXTERNAL_LINK_ARROW} svgClass="content-link__new-window-indicator" />
        {externalRegistrationUrl.name}
      </Hyperlink>
    </div>
  );
}

export const ExternalUserRegistrationBlock = asBlock(ExternalUserRegistration, BlockType.externalUserRegistration);
export type ExternalUserRegistrationBlock = ComponentProps<typeof ExternalUserRegistrationBlock>;
